//
//

import { mapGetters, mapActions } from "vuex";
import { required } from "vuelidate/lib/validators";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQRadio from "@/components/Generics/AQRadio/AQRadio.vue";

export default {
    name: "ScFunctionsDetails",
    components: {
        AQInput,
        AQDropdown,
        AQCard,
        AQRadio
    },

    props: {
        funcData: { type: Object, default: () => {} },
        activeTab: { type: String, default: "functions" },
        contractDetails: { type: Object, default: () => {} },
        functionEditMode: { type: Boolean, default: false }
    },
    data() {
        return {
            noNameError: false,
            isReadonly: false
        };
    },

    validations: {
        funcData: {
            name: {
                required
            },
            subscribed: {
                required
            }
        },
        functionTypeId: {
            required
        }

    },

    computed: {
        ...mapGetters("smartContractDesigner", ["getterScTypes"]),

        errorLabel() {
            if (this.functionError.noNameError) {
                return `${this.$t("smartContract.manageFunctions.noNameError")}`;
            } if (this.duplicateName) {
                return `${this.$t(
                    "smartContract.manageFunctions.functionDuplicateName"
                )}`;
            }
            return false;
        },

        cardTitle() {
            let cardTitle = "";
            if (this.activeTab === "functions") {
                cardTitle = this.$t("smartContract.titleDetails");
            } else {
                cardTitle = this.$t("smartContract.eventsTitleDetails");
            }
            return cardTitle;
        },

        name() {
            let name = "";
            if (this.activeTab === "functions") {
                name = this.$t("smartContract.main.funcName");
            } else {
                name = this.$t("smartContract.main.eventName");
            }
            return name;
        },

        scFunctionOptions() {
            const funcTypes = this.getterScTypes.find(type => this.contractDetails.bcType.id === type.id);
            let funcOptions = [];
            if (funcTypes) {
                funcOptions = funcTypes.functionTypeDtoList.map(funcType => ({
                    label: funcType.functionType,
                    value: funcType.id,
                    tooltipProps: {
                        tooltipContent: funcType.description
                    }
                }));
                return funcOptions;
            }
        },
        functionTypeId: {
            get() {
                if (this.funcData.functionTypeDto && this.funcData.functionTypeDto.id) {
                    return this.funcData.functionTypeDto.id;
                }
                return "";
            },
            set(value) {
                if (value.length) {
                    this.funcData.functionTypeDto = { id: value[0].value };
                    if (!this.functionEditMode && this.funcData.functionTypeDto && this.funcData.name) {
                        this.$emit("saveData", this.funcData);
                    }
                }
            }
        }
    },
    created() {
        this.getScTypes();
        this.$root.$on("function-error", error => {
            if (error) {
                Object.assign(vm.functionError, error);
            }
        });

        this.$root.$on("duplicate-name", value => {
            this.duplicateName = value;
        });
        this.isReadonly = this.contractDetails && this.contractDetails.publishStatus === "IMPORTED";
    },

    methods: {
        ...mapActions("smartContractDesigner", ["getScTypes"]),
        changeValue(value) {
            if (value === "name") {
                this.noNameError = !this.funcData.name;
            }
            this.$emit("saveData", this.funcData);
        }
    }

};
